import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Form, Container, Spinner } from 'react-bootstrap';
import {
  getPermission,
  resetPermission,
  upsertPermission,
  handleInputChange,
  fetchRolePermissionsById,
  SUPER_ADMIN
} from '../../../store/actions/permissions/permissionsActions'
import { fetchPermissions } from '../../../store/actions/permissions/permissionsActions'
import ProgressingButton from '../../../common/ProgressingButton'
import { setIsSaving } from '../../../store/actions/commonActions'
import { capitalize } from '../../../common/Utilities'


import PageTitle from '../../../common/PageTitle';

class PermissionForm extends Component {

  constructor(props) {
    super(props);
    this.pathname = this.props.location.pathname;
    this.title = 'Add Role';
  }

  componentDidMount() {

    this.props.fetchPermissions();

    const urlParams = new URLSearchParams(this.props.location.search);
    const id = urlParams.get('id');
    if (this.pathname.includes('/roles-permissions/edit')) {
      if (!id || +id === +SUPER_ADMIN) {
        window.location.replace('/#/settings/roles-permissions/new')
      } else {
        this.title = 'Edit Roles & Permissions';
        this.props.fetchRolePermissionsById(id);
        this.rolePermissions = this?.props?.permissions?.rolePermissionsByID;
      }
    } else {
      this.props.resetPermission();
    }

  }

  componentWillUnmount() {
    this.props.resetPermission();
  }

  render() {

    const rolePermissions = this?.props?.permissions?.rolePermissionsByID || {permissions: [], role: false};
    let checked = rolePermissions?.permissions?.map(p => p.id) || [];
    const roleName = rolePermissions?.role?.role_name || '';
    const roleID = rolePermissions?.role?.id || 0;

    const permissions = this?.props?.permissions?.permissions || [];

    const permissionBoxes = permissions.sort( (a,b) => { 
        return a.permission_name > b.permission_name ? 1 : -1 
      })
      .map( (box) => {
        return (
          <>
            <div className="permissionBox" key={box.id}>
              <input 
                type="checkbox" 
                id={box.permission_name} 
                defaultChecked={checked.includes(box.id)}
                onClick={e => {
                  if (e.target.checked) {
                    checked.push(box.id)
                  } else {
                    checked = checked.filter(pid => pid !== box.id);
                  }
                  this.props.handleInputChange(null, {
                    permissions: checked.map(pid => {
                      return {id: +pid}
                    })
                  });
                }}
              /><label for={box.permission_name}>{capitalize(box.permission_name)}</label>
            </div>
          </>
        )
    })

    const isReady = (!this.pathname.includes('/roles-permissions/edit') && permissionBoxes.length) || checked.length

    return isReady ? (
      <div>
        <Container className="waa-container">
            <PageTitle pageName={this.title}/>
            <hr />
            <Col>
                <Form className="waa-form">
                    <Form.Group controlId="formScreenLabel">
                      <Form.Label>Role Name</Form.Label>
                      <Form.Control 
                        type="text" 
                        value={roleName}
                        onChange={(e) => {
                          this.props.handleInputChange(null, {
                            role: {
                              id: roleID,
                              role_name: e.target.value 
                            }
                          });
                        }}
                      />
                    </Form.Group>
                    <Form.Group controlId="formCheckbox">
                      <Form.Label>Permissions</Form.Label>
                      <div style={{margin: 10}}>
                        {permissionBoxes}
                      </div>
                    </Form.Group>
                    <ProgressingButton
                      className="save-button"
                      type="submit"
                      variant="primary"
                      onClick={this.props.upsertPermission}
                      buttonValue="Save" />
                </Form>
            </Col>
        </Container>
      </div>
    ) : <Spinner animation="border" size="sm" />
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
  permissions: state.permissions,
  common: state.common,
})

const mapDispatchToProps = (dispatch) => {
  return {
    getPermission: (...args) => dispatch(getPermission(...args)),
    resetPermission: (...args) => dispatch(resetPermission(...args)),
    upsertPermission: (...args) => dispatch(upsertPermission(...args)),
    handleInputChange: (...args) => dispatch(handleInputChange(...args)),
    setIsSaving: (...args) => dispatch(setIsSaving(...args)),
    fetchPermissions: (...args) => dispatch(fetchPermissions(...args)),
    fetchRolePermissionsById: (...args) => dispatch(fetchRolePermissionsById(...args)),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PermissionForm))
